import { ProductStatus } from '../types/order/productStatus';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const LIST = '/api/product/status/list';

export namespace ProductStatusRequest {
  export const list = async (payload: { page: number }): Promise<PaginatedResponse<ProductStatus>> => {
    return (await http.post(LIST, payload)).data;
  };
}
